import { Skeleton } from "@/components/ui/skeleton";

/**
 * The single loading appearance for the workspace admin's cold boot. Used by
 * WorkspaceLayout (data still loading) and WorkspaceLanding (resolving the
 * role-based landing) so the boot shows ONE consistent skeleton instead of a
 * sequence of different spinners.
 */
const WorkspaceLoadingSkeleton = () => (
  <div className="min-h-screen flex">
    {/* Sidebar skeleton — desktop only (mobile uses the bottom nav). */}
    <aside className="hidden md:block w-64 border-r border-border bg-card/50 p-4 space-y-4">
      <Skeleton className="h-8 w-32" />
      <Skeleton className="h-6 w-full" />
      <div className="space-y-2 mt-6">
        {[1, 2, 3, 4, 5, 6].map((i) => (
          <Skeleton key={i} className="h-10 w-full" />
        ))}
      </div>
    </aside>
    {/* Main content skeleton */}
    <main className="flex-1 p-6">
      <Skeleton className="h-8 w-48 mb-2" />
      <Skeleton className="h-4 w-64 mb-6" />
      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-32 w-full" />
        ))}
      </div>
    </main>
  </div>
);

export default WorkspaceLoadingSkeleton;
